import { defineMessages } from 'react-intl';

export default defineMessages({
  searchMode: {
    id: 'appHeader.promptBar.searchMode',
    defaultMessage: 'Search',
  },
  aiMode: {
    id: 'appHeader.promptBar.aiMode',
    defaultMessage: 'AI Agent',
  },
  placeholderSearch: {
    id: 'appHeader.promptBar.placeholderSearch',
    defaultMessage: 'Search assets…',
  },
  placeholderAi: {
    id: 'appHeader.promptBar.placeholderAi',
    defaultMessage: 'Tell the AI agent what to do…',
  },
  ariaSearch: {
    id: 'appHeader.promptBar.ariaSearch',
    defaultMessage: 'Search',
  },
  ariaAsk: {
    id: 'appHeader.promptBar.ariaAsk',
    defaultMessage: 'AI Agent',
  },
  clear: {
    id: 'appHeader.promptBar.clear',
    defaultMessage: 'Clear',
  },
  submit: {
    id: 'appHeader.promptBar.submit',
    defaultMessage: 'Submit',
  },
  exampleAi1: {
    id: 'appHeader.promptBar.exampleAi1',
    defaultMessage: 'e.g. Tag all hero images',
  },
  exampleAi2: {
    id: 'appHeader.promptBar.exampleAi2',
    defaultMessage: 'e.g. Remove background on selected assets',
  },
  exampleAi3: {
    id: 'appHeader.promptBar.exampleAi3',
    defaultMessage: 'e.g. Generate a 9:16 clip from the hero video',
  },
  exampleAi4: {
    id: 'appHeader.promptBar.exampleAi4',
    defaultMessage: 'e.g. Find images uploaded last week',
  },
  exampleAi5: {
    id: 'appHeader.promptBar.exampleAi5',
    defaultMessage: 'e.g. Create a 7-day share for selected',
  },
  exampleSearch1: {
    id: 'appHeader.promptBar.exampleSearch1',
    defaultMessage: 'e.g. campaign hero images',
  },
  exampleSearch2: {
    id: 'appHeader.promptBar.exampleSearch2',
    defaultMessage: 'e.g. logo svg',
  },
  exampleSearch3: {
    id: 'appHeader.promptBar.exampleSearch3',
    defaultMessage: 'e.g. mp4 uploaded:last-week',
  },
  exampleSearch4: {
    id: 'appHeader.promptBar.exampleSearch4',
    defaultMessage: 'e.g. tag:final',
  },
  exampleSearch5: {
    id: 'appHeader.promptBar.exampleSearch5',
    defaultMessage: 'e.g. filename: brochure',
  },
  openAi: {
    id: 'appHeader.openAi',
    defaultMessage: 'Open AI Agent',
  },
  closeAi: {
    id: 'appHeader.closeAi',
    defaultMessage: 'Close AI Agent',
  },
  help: {
    id: 'appHeader.help',
    defaultMessage: 'Help',
  },
  toggleNavigation: {
    id: 'appHeader.toggleNavigation',
    defaultMessage: 'Toggle navigation',
  },
});
